import React,{useState,useEffect} from 'react';
import {Button,Form} from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { resetCommonData } from 'store/slices/commonDataSlice';
import { resetWorkspace } from '../../store/slices/workspaceSlice';
import axios from 'utils/axiosInstance';
import useAxiosFetch from 'hooks/useAxiosFetch';
import useAxiosFlowFunction from 'hooks/useAxiosFlowFunction';
import { getfeebackQuestions,saveFeedbackAnswer,enableFeedbackPopup } from 'utils/envsetup';
import useEventLogging from 'hooks/useEventLogging';
import keycloak from 'Keycloak';
import useEventTrace from 'utils/CommonRequestConfig'
import { handleProductTourEvents } from 'utils/productTour';
import { resetAuthToken } from 'store/slices/authTokenSlice';

import { setWorkspaceData } from '../../store/slices/workspaceSlice';

function Feedback(props) {
    const [, , , axiosEventLog] = useEventLogging();
  const userData=useSelector(state => state?.commonData?.userProfile);
  const userId=useSelector(state => state?.commonData?.userProfile?.userId);  
  const authFlowType = useSelector(state => state?.workSpace.isfeedBackForNewUser);
  const [feedbackresponse, error, loading] = useAxiosFetch({
    endPoint: `${getfeebackQuestions}`,
    method: 'POST',
    requestConfig: {
                    "campaignId":userData?.utmId,
                    "authFlowType":props.isFeedbackCapturedAt==="reSubmit"?"LOGIN":(authFlowType=== "true" || authFlowType=== true)?"REGISTER":"LOGIN" ,
                    "userId":userId,
                    "feedbackType": props.isFeedbackPopupSource,
                    
                  },
  });
const [, , , axiosFetch] = useAxiosFlowFunction({
    feedbackresponse: true,
  });
      const updatedQuestions = feedbackresponse?.listOfQuestions
      ?.map((question) => {
        return { ...question, answerByUser: '' };

      });
     
    
  const npsScoreArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  
   async function holdExecutionForASecond() {
    await new Promise(resolve => setTimeout(resolve, 1000));
    props.setThanksPageValue(false);
  }
  const {getProductTourReqConfig} = useEventTrace();
  const dispatch=useDispatch()
 const handleSubmission = async(isFeedbackSkippedByUser,isFeedbackGivenByUser) =>{
   await axiosFetch({
        axiosInstance: axios,
        method: 'POST',
        url: saveFeedbackAnswer,
        requestConfig: {
           "userId": userData?.userId,
           "authFlowType":props.isFeedbackCapturedAt==="reSubmit"?"LOGIN":(authFlowType=== "true" || authFlowType=== true)?"REGISTER":"LOGIN",
        "campaignName": userData?.utmId,
        "feedbackCapturedAt": props.isFeedbackCapturedAt,
        "fullName": userData?.fullname,
        "listOfQuestionsAndAnswer": questionAnswersList,
        "skippedFeedback":isFeedbackSkippedByUser,
        "userFeedback":isFeedbackGivenByUser
        },
      });
    if(!isFeedbackSkippedByUser){
    handleProductTourEvents(getProductTourReqConfig,axiosFetch,"Feedback Submitted",props.pageName,"FEEDBACK")
    }
   
     props.setIsFeedbackPopupShow(false)
      props.setThanksPageValue(isFeedbackSkippedByUser?false:true);
       holdExecutionForASecond();
       if(props.isFeedbackCapturedAt === 'logout'){
        dispatch(resetCommonData());
        dispatch(resetAuthToken());
        dispatch(resetWorkspace());
        keycloak.logout(); 
      }
      dispatch(setWorkspaceData({isfeedBackForNewUser:false}));
 }
const [questionAnswersList, setQuestionAnswersList] = useState([]);
useEffect(()=>{
  if (feedbackresponse || (feedbackresponse && feedbackresponse.length > 0)) {
    
    if (enableFeedbackPopup && updatedQuestions && props.isFeedbackPopupShow ) {
      if(props.isFeedbackCapturedAt === 'autoPopup'){
       handleProductTourEvents(getProductTourReqConfig,axiosFetch,"Feedback Opened",window.location.pathname.replace("/","").replace("-","_").toLocaleUpperCase()+'_AUTOPOPUP',"FEEDBACK")
 
     }
    else if(props.isFeedbackCapturedAt === 'logout'){
       handleProductTourEvents(getProductTourReqConfig,axiosFetch,"Feedback Opened",window.location.pathname.replace("/","").replace("-","_").toLocaleUpperCase()+'_LOGOUT',"FEEDBACK")
 
     }
     else if(props.isFeedbackCapturedAt === 'reSubmit'){
       handleProductTourEvents(getProductTourReqConfig,axiosFetch,"Feedback Opened",window.location.pathname.replace("/","").replace("-","_").toLocaleUpperCase()+'_HEADER',"FEEDBACK")
 
     }
 
     }
   } 
  else {
    if(props.isFeedbackCapturedAt === 'logout'){
    dispatch(resetCommonData());
    dispatch(resetAuthToken());
    dispatch(resetWorkspace());
    keycloak.logout()
    }
  }
  },[feedbackresponse,props.isFeedbackCapturedAt])
useEffect(() => {
    setQuestionAnswersList(updatedQuestions);
  }, [ feedbackresponse]);
const handleUserAnswer = (selectedOption, question) => {
  const updatedQuestionAnswers = questionAnswersList?.map((q) => {
    if (q.question === question) {
      return { ...q, answerByUser: selectedOption };
    }
    return q;
  });
  setQuestionAnswersList(updatedQuestionAnswers);
};
const handleClose=(()=>{
    if(props.isFeedbackCapturedAt !== 'logout'){
            props.setIsFeedbackPopupShow(false)
          }
          const isFeedbackSkippedByUser=true
          const isFeedbackGivenByUser=false
          handleSubmission(isFeedbackSkippedByUser,isFeedbackGivenByUser);
          handleProductTourEvents(getProductTourReqConfig,axiosFetch,"Feedback Closed",props.pageName,"FEEDBACK")
})

 
  const emojis = [
    { imgcode: '\u{1F625}', imgvalue: 'Very Dissatisfied' },
    { imgcode: '\u{1F61E}', imgvalue: 'Dissatisfied' },
    { imgcode: '\u{1F610}', imgvalue: 'Neutral' },
    { imgcode: '\u{1F642}', imgvalue: 'Satisfied' },
    { imgcode: '\u{1F60D}', imgvalue: 'Very Satisfied' },
  ]
const isAnyRequiredFieldEmpty = 
 questionAnswersList?.some((question) => {
  if (question?.questionType === 'mco' || question?.questionType === 'multilinetext') {
    const relatedQuestion = questionAnswersList?.find(q => q?.id === question?.optionOnNo);
    if (question?.answerByUser === 'Yes') {
      return false;
    }
    if (question?.answerByUser !== 'Yes' && relatedQuestion) {
      return relatedQuestion?.isRequired && !relatedQuestion?.answerByUser;
    }
  }
else{
  return question?.isRequired && !question?.answerByUser;
}
});
    return (
        <>
        {enableFeedbackPopup && updatedQuestions && props.isFeedbackPopupShow &&     
        <div className='feedbackmodal'>
<div style={{display: "flex",
  justifyContent: "space-between",
  alignItems: "center"}}>
<h4 className='feedbackpopuptit'>Your feedback helps us improve</h4>
          <span className='icon-ico_close' style={{cursor:'pointer',width:16,height:16}} onClick={handleClose}></span>
          </div>
        <div style={{marginBottom:20,marginTop:24}}
        >
          {
          questionAnswersList?.map(e=>{
            const question = questionAnswersList && questionAnswersList.find(q => q.id === e.optionOnNo); 
            return(
                <>
               {e?.questionType !== "multilinetext" ?e.isRequired? <h5 className='mandatory feedbackpopupqn'>{e.question}</h5>:
           <h6 className='feedbackpopupqn'>{e.question}</h6> :''}
           <div style={{marginBottom:23}}>
            {e.questionType === "mcq"?
         
            <div>
            {e.option?.map(ele => {
              return (
                <Form.Check
                onChange={() =>handleUserAnswer(ele, e.question)}
                  type="radio"
                  label={ele}
                  name="formHorizontalRadios"
                  id="formHorizontalRadios1"
                />
              );
            })}
          </div>        
       :
          e.questionType === "mco" ?
          
          <div>
          {e.option?.map(ele => {
            return (
              <>
            {e.questionType === "mco"  &&   <div className='mcqbackground'>
              <Form.Check
              onChange={() =>handleUserAnswer(ele, e.question)}
                type="radio"
                label={ele}
                name="formHorizontalRadios"
                id="formHorizontalRadios1"
              />
              </div>
             } 
             </>
            );
          })}
            {e?.answerByUser && e?.answerByUser !== "Yes" && question?.questionType === "multilinetext" &&  <>  {question.isRequired? <h5 className='mandatory feedbackpopupqn' style={{marginTop:15}}>{question.question}</h5>:
            <h6 className='feedbackpopupqn' style={{marginTop:15}}>{question.question}</h6> }
                  <Form.Control
                     className='feedbackformtxtcntrl'
              maxLength={ question?.maximumLength}
               type="text"
               as={"textArea"}
               style={{ height: 109,resize:'none' }}
               onBlur={event => handleUserAnswer(event.target.value, question.question)}
             />
             </>}
        </div>

          :e.questionType === "rating"?
          
                        <div style={{ justifyContent: 'center', display: 'flex',alignItems:'center',height:"50px",width:'212px',marginLeft:20 }}>

          {emojis.map(ele=>{
            return(
          <span
            role="img"
            aria-label="Very Dissatisfied"
            style={{ cursor: 'pointer', fontSize:e.answerByUser === ele.imgvalue?'40px': '35px',background:e.answerByUser === ele.imgvalue?'#FEE1E1':'', borderRadius:e.answerByUser === ele.imgvalue? '50%':'',padding:e.answerByUser === ele.imgvalue?'5px 5px 0px 5px':'0px' }}
            onClick={() => handleUserAnswer(ele.imgvalue, e.question)}
            >

           {ele.imgcode}

          </span>
    
         
            
          )})
          }
          </div>
          :e.questionType === "comments"?<>
          <Form.Control
             className='feedbackformtxtcntrl'
             maxLength={e?.maximumLength}
              type="text"
              style={{ height: 80 }}
              onBlur={event => handleUserAnswer(event.target.value,e.question)}
              placeholder="Write your message here"
            />
          </>:
          
        e.questionType === "nps"?<> {
          npsScoreArray.map(ele => {
          return (
            <Button
              className="feedbackButtonHover"
              style={{
                //padding: 11,
                margin: '5px',
                // marginRight: e === 10 ? '' : '5px',
                borderRadius: '4px',
                backgroundColor: e.answerByUser === ele ? '#3f02c0' : '#814bf5',
                border: 'none',
              }}
              onClick={()=>handleUserAnswer(ele,e.question)}
            >
              {ele}
            </Button>
          );
        })}
        </>:<></>
          
          }
          </div>
          
          </>
          )
        })} 
          
         
        </div>
        <div style={{display:"flex", justifyContent: 'center',marginTop:10 }}>
          <Button
            className={'delbut'}
            style={{borderRadius:8,width:'100%'}}
            disabled={ isAnyRequiredFieldEmpty}
            onClick={() => {
              const isFeedbackSkippedByUser=false
              const isFeedbackGivenByUser=true
              handleSubmission(isFeedbackSkippedByUser,isFeedbackGivenByUser);
              
            
            }}
          >
            Submit Feedback
          </Button>
        </div>
      </div>
}
 

        </>
    );
}

export default Feedback;